var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#EC0C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0026 13.0192C9.78073 13.0192 9.59085 12.8299 9.55233 12.5694L8.41734 4.91428C8.27466 3.9502 8.89749 3.06641 9.71943 3.06641H10.2853C11.1072 3.06641 11.7301 3.9502 11.5874 4.91428L10.4524 12.5694C10.4144 12.8299 10.2245 13.0192 10.0026 13.0192ZM11.041 15.899C11.041 15.3271 10.5745 14.8606 10.0026 14.8606C9.4308 14.8606 8.96422 15.3271 8.96422 15.899C8.96422 16.4708 9.4308 16.9374 10.0026 16.9374C10.5745 16.9374 11.041 16.4714 11.041 15.899Z",
    fill: "#E6E9ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaring);
export default __webpack_public_path__ + "static/media/Waring.cbbeeddfb3240b347ba92f844e11f0f5.svg";
export { ForwardRef as ReactComponent };